import {
  OVERVIEW,
  PRESS_NEWS,
  FINANCIAL_INFORMATION,
  STOCK_INFORMATION,
  ABOUT_US,
  GOVERNANCE,
  SHAREHOLDER_SERVICES,
  LATEST_PRESENTATION,
} from '@/pages/irWebTool/ContentSetup/constants';

const InitialState = {
  company: {},
  air_identifier: null,
  air_jwt: null,
  setupId: null,
  setup: {
    published: null,
    draft: null,
    copy: null,
    saved: null,
  },
  ids: {
    overview: 0,
    press_news: 0,
    financial_information: 0,
    stock_information: 0,
    about_us: 0,
    governance: 0,
    shareholder_services: 0,
    latest_presentation: 0,
    appearance: 0,
    legal: 0,
  },
  list: {
    overview: OVERVIEW,
    press_news: PRESS_NEWS,
    financial_information: FINANCIAL_INFORMATION,
    stock_information: STOCK_INFORMATION,
    about_us: ABOUT_US,
    governance: GOVERNANCE,
    shareholder_services: SHAREHOLDER_SERVICES,
    latest_presentation: LATEST_PRESENTATION,
  },
  overviewSections: {
    section1: '',
    section2: '',
    section3: '',
  },
  step: 0,
  missingAssets: true,
};

const mutations = {
  airUser(state, data) {
    return Object.assign(state, {
      air_identifier: data.air_identifier,
      air_jwt: data.air_jwt,
    });
  },
  setError(state, current) {
    const name = current[0];
    const status = current[1];
    return Object.assign(state.list[name], { error: status });
  },
  setOverview(state, current) {
    const name = current[0];
    const status = current[1];
    return Object.assign(state.list[name], { in_overview: status });
  },
  setOverviewSections(state, current) {
    const section = current[0];
    const item = current[1];
    return Object.assign(state.overviewSections, { [section]: item });
  },
  saveForm(state, current) {
    const name = current[0];
    const status = current[1];
    return Object.assign(state.list[name], { is_saved: status });
  },
  changeStep(state, step) {
    return Object.assign(state, { step });
  },
  setIds(state, id) {
    return Object.assign(state.ids, id);
  },
  setPublished(state, setup) {
    return Object.assign(state.setup, { published: setup });
  },
  setSaved(state, setup) {
    return Object.assign(state.setup, { saved: setup });
  },
  setDraft(state, setup) {
    return Object.assign(state.setup, { draft: setup });
  },
  setCopy(state, setup) {
    return Object.assign(state.setup, { copy: setup });
  },
  setCompany(state, current) {
    return Object.assign(state, { company: current });
  },
  setWebsiteDomain(state, domain) {
    return Object.assign(state.company, { website_domain: domain });
  },
  setSetupId(state, setupId) {
    return Object.assign(state, { setupId });
  },
  setMissingAssets(state, data) {
    return Object.assign(state, { missingAssets: data });
  },
  updateList(state, data) {
    return Object.assign(state.list, data);
  },
};

const actions = {
  goNextStep(context) {
    const step = context.state.step;
    let nextStep = context.state.step + 1;
    if (step === 3) nextStep = -1; // if it's last page of form, goes to content review (-1)
    if (step === -1) nextStep = 1; // if it's in content review, goes to the first page of form (1)
    context.commit('changeStep', nextStep);
  },
};

const getters = {
  list: (state) => state.list,
  company: (state) => state.company,
  air_jwt: (state) => state.air_jwt,
  air_identifier: (state) => state.air_identifier,
  setup: (state) => state.setup,
  setupId: (state) => state.setupId,
  step: (state) => state.step,
  missingAssets: (state) => state.missingAssets,
  ids: (state) => state.ids,
};

export default {
  state: InitialState,
  mutations,
  actions,
  getters,
  namespaced: true,
};
